export default "__VITE_ASSET__DsMfoNj3__"